const URL_REGEX = /^https?:\/\/.+\.\w{2,}/i;

export default function isUrl(text: string) {
  return URL_REGEX.test(text);
}
